

import { Message,MessageBox } from 'element-ui'
import {Req_GetOssConfig} from '@/request/upload'
import {Req_ChangeExcelToPdf} from '@/request/excel'
import Vuex from 'vuex'
import JsEncrypt from 'jsencrypt'

export const getPath = client => {
  const prefix = {
    'act': 'act',
    'mag': 'www',
    'crm': 'crm',
    'con': 'con'
  }
  if (location.href.includes('192.168.13.34')) { //pujun
    const server34 = {
      'act': ':8080',
      'mag': '',
      'crm': ':8081',
      'con': ':8082'
    }
    return `http://192.168.13.34${server34[client]}`
  } else if (location.href.includes('ccqf.inforshare.com')) { // 32 
    return `http://${prefix[client]}.ccqf.inforshare.com`
  } else if (location.href.includes('www.ccqf.vip')) { // waiwang
    return `https://${prefix[client]}.ccqf.vip`
  } else if (location.href.includes('localhost')) { 
    const dev_port = {
      'mag': ':8081',
      'act': ':8082',
      'crm': ':8083'
    }
    return `http://localhost${dev_port[client]}`
  }
  return  ''
}


export function decrypt(pwd) {
  if(pwd && pwd != '********') { 
    const decrypt = new JsEncrypt()
    decrypt.setPrivateKey('MIIEvQIBADANBgkqhkiG9w0BAQEFAASCBKcwggSjAgEAAoIBAQCAEQ6iI9a9L6IInu0tur13f+yygHgrg+x9OqqMbbYT7n0LG98RNKgs4vxQREk94JEuczqR8CSZCLn/GqYBurIxoBWgg1EIAcSQYnHADqvFcKZ2Cyl8ojAfNaWY6PwFgfT24u11tZLQLBnWwW2gj6wenbTSW8zKr6nqCOKWHn+Rslr9h+1cDJkBziEg/Rv6MgBNi4HlnUk2MIkytJFiqepkQyW5MiaLv5b7dtA1x7H9qBGTCpjjhFfGLKQkSlcW2B614MZ4+vUY+LwoxD2DMrMWPmVvSKHcDgsWBWjIe8MZp54WhPzYBdyH8y3TzW/2QPkJ7sld52ilgs69nZYruSmLAgMBAAECggEAVasTXuMagvOaMKoffreshoPMkpvdxz44tIzKCaZaZnriqsu6LIhM97nfjtIfLIVMmQX76CP8V2K/CSeKZR2+lfPAg99UFUcZdnxkG1W1Eh6JO+27kuPrzPTWEbPI4uZMN9sVfeg4jYjyv/Ykn4N8X/6fNxixpeRchXHsIP/F1m+/DFn7SbGvmelRWY7vPAd8K8n+z0ZO3CVAqL7gzbxSbbUae68jjgSIkTWdTNyuSKka6BIEmkEW3kap9cS3ArfSh/A0LjB05nxawxGVD8tQm2jjXWfST2IAmXtufBZB92rnEZIXa33jd0wNQz2Rgq4rWD0w9rf0EGue3vsJ/NsGAQKBgQDol7LkRDkV/VHEnsJMYpfs1qs8eOiYH+Nz8eIUL4l2477ym79cn57TmU82yIslTkxgePc8YHAYtVhwPWF0nBqDsvDIJLtpWX1I8J3QwEh30lQ4dKz/z+WmtGzN+P7EsUU9EcXo7xE9CORxqrmFmn+P5g5ybRM7gFtMor7cPDzvJQKBgQCM9HKzrQ16WquSTtdZbovrjOPCeWHsTs15s+52ZigcjY1+siJBh7x5QmYc9m2JGnrgdt7Hgwu8071biZSJHcixb6y+/hP9OcaPoCjmZmqaVqOMnXxV3AQMNYUf58CmIR1vnUPiOA9xl3IeXDbsmWvu5TpaX/WPwk55Et7cXYRu7wKBgQDmHnBXd0gjgWWM6qXBfSpioGD6i4VUPPiEliPfZMjUX69jyMQjl6lEIMJGqVNBrZ3TNNsnWSKOz5yYL6JkBK4W7stauTzSlj9mEumQxyzrn6TD1mvzDHVh4dBkWJ13bQvbx+HO+/hKMqoR659xl9HtROe2PkRw8iViRQIgU1jWIQKBgHAr0GQAYWtvYH5MU8AN4zeOpWoMIstlYstpT2nVnjIqy+F5bR1tIaX2G0ENMtoawpKCxoNLXDnm3xhLgnMjyqS51GUh2VJ5efSuZh4Efu1X6UtrwJirQGVe6hQb4AnU7JH4Ox95sYCaHuzeQa9D4Mr6jNeC6e5/mOdtBwGjQlLtAoGAU75kKI92h0OSwry4UQetX0lzi47QZrZf015lpvlWqtmx5utpUkrldYPOvhqDKhB2WWI+WNcSI/Gu4PIwLdKI3wNjbza8Vdcr6OkFze8WBJZRol/4SLi45VPzROh5x53Dv1UlGLkeyhvf38mYbKvTBa6Gxd12QEuUVHGDJg+OcHQ=')   
    return  decrypt.decrypt(pwd)
  } else {
    return null
  }
}

export function encrypt (pwd) {
  if(pwd && pwd != '********') {
    const encrypt = new JsEncrypt()
    encrypt.setPublicKey('MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAgBEOoiPWvS+iCJ7tLbq9d3/ssoB4K4PsfTqqjG22E+59CxvfETSoLOL8UERJPeCRLnM6kfAkmQi5/xqmAbqyMaAVoINRCAHEkGJxwA6rxXCmdgspfKIwHzWlmOj8BYH09uLtdbWS0CwZ1sFtoI+sHp200lvMyq+p6gjilh5/kbJa/YftXAyZAc4hIP0b+jIATYuB5Z1JNjCJMrSRYqnqZEMluTImi7+W+3bQNcex/agRkwqY44RXxiykJEpXFtgeteDGePr1GPi8KMQ9gzKzFj5lb0ih3A4LFgVoyHvDGaeeFoT82AXch/Mt081v9kD5Ce7JXedopYLOvZ2WK7kpiwIDAQAB')
    return encrypt.encrypt(pwd)
  } else {
    return null
  }
}


export const getPageNumAfterDel = function (query,remain) {
  const {pageNum,totalPages} = query
  let num = pageNum
  console.log(remain)
  if(!remain && pageNum === totalPages && pageNum !== 1) {
    num --
  }
  return num
}


export const Cookie =
{
  set: function (name, value, days = 2) {
    var  date, expires;
    if (days) {
      date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toGMTString();
    } else {
      expires = "";
    }   
    if(location.host.includes('ccqf.inforshare.com')) {
      
      document.cookie = name + "=" + value + "; path=/; domain=.ccqf.inforshare.com" + expires
      // alert(name + "=" + value + "; path=/; domain=.ccqf.inforshare.com" + expires)
    } else if (location.host.includes('ccqf.vip')) {
      document.cookie = name + "=" + value + "; path=/; domain=.ccqf.vip" + expires
    }else {
      document.cookie = name + "=" + value + "; path=/" + expires
    }
  },
  get: function (name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1, c.length);
      }

      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  },

  erase: function (name) {
    Cookie.set(name, '', -1);
  }
}



export const strAdd = function (str) {
  const arr = []
  for (let i = str.length - 1; i > -1; i--) {
    arr.push(str[i])
  }
  for (let i = 0; i < arr.length; i++) {
    if (arr[i] === '9') {
      arr[i] = '0'
    } else {
      arr[i] = `${Number(arr[i]) + 1}`
      return arr.reverse().join('')
    }
  }
}

window.$loginOrder = 0

export const loginTimeout = () => {
  Message.error('登录状态已过期，请重新登录')
  localStorage.removeItem('token')
  setTimeout(() => {
   
    location.href = `${getPath('mag')}/#/login`
  }, 800)
}

export const catchError = function (err) {
  const store = this.constructor === Vuex.Store ? this : this.$store
  if (window.$request) window.$request.state = false
  if (!err || !err.message) {
    return console.error('缺少必要参数')
  }
  if (err.code === 999) {
    if (window.$loginOrder === err.loginOrder) {
      window.$loginOrder++
      loginTimeout()
    }
  }else if(err.code == 711 && store.state.showErrTips){
    store.commit('setErrorTipsShowState', false)
    store.commit('setShowCheckPassword',true)
  } else {
    if(store.state.showErrTips){
      if(err.constructor === Error) {
        MessageBox.confirm(`
          <p>系统内部错误，请联系开发人员</p>
          <p style="font-size:12px;color:#a5a5a5;word-break:break-all">时间：${new Date()} 消息：${err.request.custom.url} ${err.message}</p>
        `,'错误提示',{
          dangerouslyUseHTMLString: true
        })
      } else {
        Message.error(err.message)
      }
    }
  }
}

export const deepClone = function (obj) {
  return JSON.parse(JSON.stringify(obj))
}

export const filterProp = function (props, obj) {
  const isArr = (Object.prototype.toString.call(props) === '[object Array]')
  if (!isArr) return console.error('第一个参数需传入一个数组')
  const newObj = {}
  props.forEach((prop, index) => {
    if (typeof prop === 'string') return newObj[prop] = obj[prop]
    if (typeof prop === 'object') {
      if (!prop.name || !prop.alias) return console.error(`数组中第${index}项存在非法的name或alias`)
      newObj[prop.alias] = obj[prop.name]
    }
  })
  return newObj
}

//模糊搜索
export function fuzzyFilter(target,inputValue){
  if(!target && !inputValue) return false
  const obj = {}
  const {originalName,firstLetter,pinyin} = target.data
  if(originalName === null || firstLetter === null || pinyin === null) return false
  const v_text_arr = inputValue.toLowerCase().split('&&')
  obj.n_text = target.data.originalName.toLowerCase().split('')
  obj.f_text = target.data.firstLetter.toLowerCase().split(',')
  obj.p_text = target.data.pinyin.toLowerCase().split(',')
  // console.log(obj.n_text,obj.f_text,obj.p_text,inputValue)
  for(let item of v_text_arr) {
    if(item) {
      obj.v_text = item.split('')
      if (!selectCascaderFliter(obj,findStartIndex(0,obj))) {
        return false
      } 
    }
  }
  return true
}

export function selectCascaderFliter(data,startIndex) {
  const {v_text,n_text,p_text,f_text} = data
  // console.log(v_text,n_text,p_text,f_text,startIndex,n_text.join('') === v_text.join(''))
  if(n_text.join('') === v_text.join('')){
    // console.log(2)
    return true
  }else{
    if(startIndex === false) return false
    let i = 0
    for(i = 0; i < v_text.length; i++) {
      if(n_text[startIndex] === v_text[i]) {
        startIndex++
        continue
      } else if(f_text[startIndex] === v_text[i]) {
        let p_res = true
        for(let j = 0; j < p_text[startIndex].length; j++) {
          if(p_text[startIndex][j] !== v_text[i+j]) {
            p_res = false
          }
        }
        if(p_res) {
          
          i = i + p_text[startIndex].length - 1
        }
        startIndex++
      } else {
        return selectCascaderFliter(data,findStartIndex(startIndex,data))
      }
    }
    return true
  }
}

export function findStartIndex(index,data) {
  const {v_text,n_text,p_text,f_text} = data
  const len = n_text.length
  for(let i = index; i < len; i++) {
    if(v_text[0] === n_text[i]) {
      // console.log(1,v_text,n_text,p_text,f_text)
      return i
    }
    if(v_text[0] === f_text[i]) {
      return i
    }
    if(v_text[0] === p_text[i]) {
      return i
    }
  }
  return false  // 拼音，首字母，中文都没找到
}

export function initColFixedObj(len = 0) {
  const obj = {}
  for(let i = 0; i <= len; i++) {
    obj[i] = false
  }
  return obj
}


//中缀表达式转后缀表达式
function middleToLast(exp) {
  // console.log(exp.length)
  const m_arr = []
  for(let i = 0; i < exp.length; i ++) {
    const currentIsNum = /[0-9.]/.test(exp[i])
    const lastIsNum = /[0-9.]/.test(m_arr[m_arr.length - 1])
    // console.log(currentIsNum,lastIsNum,m_arr[m_arr.length - 1],exp[i])
    if(currentIsNum && lastIsNum) {
      let target = m_arr[m_arr.length - 1]
      // console.log(target,m_arr)
      m_arr[m_arr.length - 1] = `${target}${exp[i]}`
    }else {
      m_arr.push(exp[i])
    }
  }
  let l_arr = []
  let stack = []
  function  stackControl(item) {
    const head = stack[stack.length - 1]
    if(item === '+' || item === '-') {
      if(!head) {
        stack.push(item)
      }else {
        if(head === '+' || head === '-' || head === '*' || head === '/') {
          stack.pop()
          l_arr.push(head)
          stackControl(item)
        }else {
          stack.push(item)
        }
      }
    }
    if(item === '*' || item === '/' || item === '(') {
      stack.push(item)
    }
    if(item === ')') {
      if(head !== '(') {
        stack.pop()
        l_arr.push(head)
        stackControl(item)
      }else {
        stack.pop()
      }
    }
  }
  m_arr.forEach(item => {
    if(Object.is(Number(item),NaN)) {
      stackControl(item)  
    }else {
      l_arr.push(item)
    }
  })
  l_arr = [...l_arr,...stack.reverse()]
  return l_arr
}


export function fourExpGetRes(value) {
  try {
    const stack = []
    const RPN = middleToLast(value)
    RPN.forEach(item => {
      if(Object.is(Number(item),NaN)) {
        const end = Number(stack.pop())
        const front = Number(stack.pop())
        // console.log(end,front)
        if(isNaN(end)||isNaN(front)){
          throw('err')
        }
        let res = 0
        if(item === '+') {
          res = front + end
        }else if(item === '-') {
          res = front - end
        }else if(item === '/'){
          res = front / end
        }else if(item === '*') {
          res = front * end
        }
        stack.push(res)
      }else {
        stack.push(item)
      }
    })
    // console.log(stack)
    return stack[0]
  }catch(e) {
    return false
  }
}

export function changePdf(blod,name,type,direction=1,bookPrintType,pdfStyle,paperStyle,pdfNewData){
  const file = new File(blod,name,type)
  const fileSize = Math.ceil(file.size / 1024 / 1024)
  const parmas = {
    file,
    bookPrintType,
    pdfStyle,
    paperStyle,
    name,
    pdfNewData
  }
  // console.log(parmas,pdfNewData,123456)
  ossUploadFun(handleRequestPdfData,parmas)
}

function ossUploadFun(fn,parmas){
  getOssConfig().then(res => {
    // console.log(res)
    let client = new OSS({
      region: res.region,
      //阿里云账号AccessKey拥有所有API的访问权限，建议遵循阿里云安全最佳实践，创建并使用STS方式访问API。
      accessKeyId: res.accessKeyId,
      accessKeySecret: res.accessKeySecret,
      stsToken: res.stsToken,
      bucket: res.bucket,
      secure:true
    })
    localStorage.removeItem('printDirection')
    client.put(`caichen/excel/${parmas.name}.xlsx`,parmas.file).then(ossRes => {
      parmas.ossUrl = ossRes.url
      fn(parmas)
    }).catch(ossErr => console.log(ossErr))
  }).catch(err => console.log(err))
}

//获取oss配置
function getOssConfig(){
  return Req_GetOssConfig()
}

function handleRequestPdfData(data = {ossUrl,bookPrintType,pdfStyle,paperStyle,name,pdfNewData:{}}){
  // const params = new FormData()
  // console.log(data,456)
  let params = {}
  const keyList = ['leftMargin','rightMargin','bottomMargin','zoom','standardHeight','orientation','topMargin']
  // params.append('file',file)
  // params.append('fileName',name)
  // params.append('bookPrintType',bookPrintType)
  params.excelUrl = data.ossUrl
  params.fileName = data.name
  params.bookPrintType = data.bookPrintType
  if(data.paperStyle === '特殊'){
    // params.append('pageWidth',575) 
    // params.append('pageHeight',310)
    params.pageWidth = 575
    params.pageHeight = 310
  }
  if(data.pdfStyle){
    keyList.forEach(key => {
      if(data.pdfStyle[key] || data.pdfStyle[key] === 0){
        // params.append(key,pdfStyle[key])
        params[key] = data.pdfStyle[key]
      }
    });
  }
  params = {...params,...data.pdfNewData}
  Req_ChangeExcelToPdf(params).then(res => {
    window.open(res)
  }).catch(err => {
    MessageBox(err.message, 'pdf文件过大提示', {
      confirmButtonText: '确定',
      type:'warning',
      callback: () => {}
    });
    console.log(err)
  })
}

export const encruption = function (pwd) {
  const encrypt = new JsEncrypt()
  encrypt.setPublicKey('MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAgBEOoiPWvS+iCJ7tLbq9d3/ssoB4K4PsfTqqjG22E+59CxvfETSoLOL8UERJPeCRLnM6kfAkmQi5/xqmAbqyMaAVoINRCAHEkGJxwA6rxXCmdgspfKIwHzWlmOj8BYH09uLtdbWS0CwZ1sFtoI+sHp200lvMyq+p6gjilh5/kbJa/YftXAyZAc4hIP0b+jIATYuB5Z1JNjCJMrSRYqnqZEMluTImi7+W+3bQNcex/agRkwqY44RXxiykJEpXFtgeteDGePr1GPi8KMQ9gzKzFj5lb0ih3A4LFgVoyHvDGaeeFoT82AXch/Mt081v9kD5Ce7JXedopYLOvZ2WK7kpiwIDAQAB')
  return encrypt.encrypt(pwd)
}





// WEBPACK FOOTER //
// ./src/util/index.js